import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/common.css';

const Footer = () => {
  // 検証用：広告の表示状態を管理
  const [isAdVisible, setIsAdVisible] = useState(true);

  // 検証用：広告を非表示にする関数
  const hideAd = () => {
    setIsAdVisible(false);
  };

  return (
    <footer className="footer">
      {/* 検証用：条件付きレンダリングで広告の表示/非表示を制御 */}
      {isAdVisible && (
        <a 
          href="https://store.stpr.com/collections/stprfamily-schoolfestival?utm_source=stprschedule&utm_medium=display&utm_campaign=scheduletop01" 
          target="_blank" 
          className="ad_float"
          style={{ }}
        >
          <img src="/images/footer/20250912.jpg" alt="STPR Family School Festival!! OFFICIAL GOODS"/>
          {/* 検証用：×ボタン（白色、黒縁2px、右上配置） */}
          <span
            onClick={(e) => {
              e.preventDefault(); // リンクのクリックを無効化
              hideAd();
            }}
            style={{
              position: 'absolute',
              top: '-40px',
              right: '8px',
              padding: '0px 11px 4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#ffffff',
              cursor: 'pointer',
              zIndex: 10,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              borderRadius: '50%'
            }}
          >
            ×
          </span>
        </a>
      )}
      <div className="footer-content">
        {/* フッター内広告バナー */}
        <div className="ad-banner-footer">
          <a href="https://store.stpr.com/?utm_source=stprschedule&utm_medium=display&utm_campaign=commonfooter01" 
             target="_blank" 
             rel="noopener">
            <img src="/images/footer/20250919.png" 
                 alt="STPR ONLINE STORE" />
          </a>
        </div>
        
        <Link to="/privacy" className="privacy-link">
          プライバシーポリシー
        </Link>
        <p className="copyright">Copyright © STPR Inc.</p>
      </div>
    </footer>
  );
};

export default Footer;
